import { makeStyles } from '@material-ui/core/styles';
import { TextColors, SecondaryColors } from '@/utils/constants';

const darkTheme = {
  headerCard: {
    color: TextColors.light,

    '& $superHeading': {
      color: SecondaryColors.main,
    },
  },
};

const lightTheme = {
  headerCard: {
    color: TextColors.dark,

    '& $superHeading': {
      color: SecondaryColors.dark,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    headerCard: {
      '&.dark-theme': darkTheme.headerCard,
      '&.light-theme': lightTheme.headerCard,

      '&.with-featured': {
        marginBottom: muiTheme.spacing(3),
      },
    },
    superHeading: {
      '&.Muitypography-root': {
        '&:not(:last-child)': {
          marginBottom: muiTheme.spacing(2),
        },
      },
    },
    title: {
      '&.Muitypography-root': {
        color: 'inherit',
        marginBottom: '-.125em',
      },
    },
    contentCards: {
      '& .column': {
        display: 'flex',
      },
      '& .MuiCard-root': {
        width: '100%',
      },
    },
    card: {
      '& .MuiCardContent-root': {
        padding: muiTheme.spacing(7),

        '&.MuiCardContent-root:last-child': {
          paddingBottom: muiTheme.spacing(7),
        },
      },
    },
  }),
  { name: 'GenFeaturedContentRowType' },
);

export default useStyles;
